export enum DialogEditMode {
  EDIT = 'EDIT',
  CREATE = 'CREATE',
}
